import React from 'react';
const OpenIcon = () => (React.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "openTitle", role: "img" },
    React.createElement("title", { id: "openTitle" }, "mobile open menu button"),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0L24 0 24 24 0 24z" }),
        React.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z", fill: "#404040", fillRule: "nonzero" }))));
export default OpenIcon;
//# sourceMappingURL=OpenIcon.js.map